import { render } from "./FormDisplayonly.vue?vue&type=template&id=680a1659"
import script from "./FormDisplayonly.vue?vue&type=script&lang=js"
export * from "./FormDisplayonly.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__